import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import storage from "../../Services/Storage";
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader";
import * as Fa from "react-icons/fa";

import { createAPIEndpointDiscountDefinition, EndpointDiscountDefinition } from "../../Services/DiscountDefinition/DiscountDefinitionService";

const DiscountDefinitionAllRecords = () => {
    const [getAllRecords, setGetAllRecords] = useState([]);
    const auth = storage.getLocal("user");
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const [endDate, setEndDate] = useState(new Date());
    // const [discountId, setDiscountId] = useState("'");
    const [isLoading, setIsLoading] = useState(false);

    const nav = useNavigate();

    const getAllRecordsData = async () => {
        setIsLoading(true);
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(
            startDate
        );
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
        createAPIEndpointDiscountDefinition()
            .get(
                `${EndpointDiscountDefinition.GetAllDiscountData}?CompId=${auth.CompId}&Scope=S&UserId=${auth.UserId}&StartDate=${formattedStartDate}&EndDate=${formattedEndDate}`
            )
            .then((response) => {
                if (!response.data || response.data.length === 0) {
                    toast.error("No data found.", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                    setGetAllRecords([]);
                    setIsLoading(false);
                    return;
                }

                setGetAllRecords(response.data);
                setIsLoading(false);
            })
            .catch((error) => {
                toast.error(
                    "An error occurred while fetching the discount data. Please try again later.",
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    }
                );
                console.log(error);
            });
    };

    const deleteDiscount = async (data) => {
        setIsLoading(true);
        // setDiscountId(data.MASK_DISCOUNT_ID);
        try {
            let response = await createAPIEndpointDiscountDefinition().post(
                `${EndpointDiscountDefinition.DeleteDiscount}?CompId=${auth.CompId}&DiscountId=${data.MASK_DISCOUNT_ID}`
            );
            if (response.data.IsSaved == false) {
                toast.warn(`${response.data.ErrorMsg}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            } else {
                toast.error("Record deleted successfully", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,   
                    autoClose: 2000,
                });
            }
        } catch (err) {
            console.log("Error ", err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleViewEdit = (rowData) => {
        nav(
            `/masters/discountdefinition/details?DISCOUNT_ID=${rowData.MASK_DISCOUNT_ID}`
        );
    };

    // const add = () => {
    //     nav('/masters/discountdefinition/details ', { state: { data: [], json: {} } });
    // }

    // useEffect(() => {
    // }, [startDate, endDate, getAllRecords, jsonData, isLoading]);

    useEffect(() => {
        getAllRecordsData();
    }, []);

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    {

                        isLoading ? <Loader/> :
                            <>            <div className="col-12 pt-0 pb-4">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <h3 className='py-2'>Discount Definition</h3>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="float-end mb-2">
                                            <button type="button" className="btn btn-primary" onClick={()=>nav(`/masters/discountdefinition/details?DISCOUNT_ID=${""}`)}>
                                Add New 
                                            </button>
                                            {/* <button type="button" className="btn btn-primary" onClick={add}>
                                Add New
                            </button> */}
                                        </div>
                                    </div>
                                </div>
                                <section className="sales-box">
                                    <div className="row d-flex justify-content-end align-items-end">
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="d-block">
                                                <label className="form-label">Discount Creation From Date</label>
                                                <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} showIcon />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="d-block">
                                                <label className="form-label">Discount Creation To Date</label>
                                                <Calendar value={endDate} onChange={(e) => setEndDate(e.value)} showIcon />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="text-end">
                                                <button className="btn btn-primary" onClick={getAllRecordsData}>Get All Discount</button>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <section className="">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <h3 className='py-2'>Records</h3>
                                        <div className="DataTable">
                                            <DataTable
                                                value={getAllRecords}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                scrollHeight="80vh"
                                                // showGridlines
                                                scrollable
                                                stripedRows
                                                emptyMessage="No Record found"
                                                filterDisplay="row"
                                            >
                                                <Column field="DISCOUNT_NAME" header="Discount Name" filterMatchMode="contains" filter filterPlaceholder="Search Here..."></Column>
                                                <Column field="MASK_FIRST_ENTERED_ON" header="Discount Creation Date"></Column>
                                                <Column header="Action " body={(rowData) => (
                                                    <>
                                                        <div className="action-icon">
                                                            <button
                                                                className="grid-icon-img"
                                                                onClick={() => handleViewEdit(rowData)}
                                                                title="View/Edit"
                                                            >
                                                                <img
                                                                    alt="InnoRise"
                                                                    src={require("../../Assets/Images/ViewEdit.png")}
                                                                />
                                                            </button>
                                                            <button
                                                                className="grid-icon"
                                                                title="Delete"
                                                                onClick={() => {
                                                                    deleteDiscount(rowData);
                                                                }}
                                                            >
                                                                <Fa.FaTrashAlt className="cancel" />
                                                            </button>
                                                        </div>
                                               
                                                    </>
                                                )}></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            </>
                    }
                </>
            )}
        </>
    );
};

export default DiscountDefinitionAllRecords;
